<template>
    <div class="container mt-5">
        <!-- <Breadcrumb class="my-3" /> -->
        <CommonBreadcrumb class="my-3" />
        <h1 class="mb-4 font-active">Sitemap</h1>
        <div class="row">
            <div class="col-lg-3 col-md-4 for_desktop">
                <div class="left_cta sticky">
                    <ul class="ps-0 mb-0">
                        <!-- <li><router-link :to="localePath('/')">Home</router-link></li> -->
                        <li><a :class="{ active: activeMenuItem === 'menu-item-1' }" href="#cyo">Create Your Own</a></li>
                        <li><a :class="{ active: activeMenuItem === 'menu-item-2' }" href="#eng_ring">Engagement Rings</a></li>
                        <li><a :class="{ active: activeMenuItem === 'menu-item-3' }" href="#wedding_ring">Wedding Rings</a></li>
                        <li><a :class="{ active: activeMenuItem === 'menu-item-4' }" href="#loose">Lab Diamonds</a></li>
                        <li><a :class="{ active: activeMenuItem === 'menu-item-5' }" href="#jewelry">
                            <span>{{ $t('jewelry') }}</span>
                        </a></li>
                        <li><a :class="{ active: activeMenuItem === 'menu-item-6' }" href="#about">About Us</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-9 col-md-8">
                <!-- <h1 class="for_desktop mb-4" v-font="$getFont('NewYork', 600)">Sitemap</h1> -->
                <div ref="div1" class="right_cta" id="cyo">
                    <div class="right_cta_box">
                        <h2>Create Your Own Ring</h2>
                        <ul class="">
                            <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">Choose an Engagement Ring Setting</NuxtLink></li>
                            <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring'})">Choose a Lab Diamond Ring</NuxtLink></li>
                        </ul>
                    </div>
                    <div class="right_cta_box">
                        <h2>Create Your Own Pendant</h2>
                        <ul class="">
                            <li><NuxtLink :to="localePath({ name:'cyo-setting-list-pendant'})">Choose a Pendant Setting</NuxtLink></li>
                            <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-pendant'})">Choose a Lab Diamond Pendant</NuxtLink></li>
                        </ul>
                    </div>
                    <div class="right_cta_box">
                        <h2>Create Your Own Earrings</h2>
                        <ul class="">
                            <li><NuxtLink :to="localePath({ name:'cyo-setting-list-earring'})">Choose an Earring Setting</NuxtLink></li>
                            <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-earring'})">Choose Lab Diamond Earrings</NuxtLink></li>
                        </ul>
                    </div>
                </div>
                <div ref="div2" class="right_cta pt-5" id="eng_ring">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="right_cta_box">
                                <h2><NuxtLink :to="localePath('/engagement-rings')">Engagement Rings</NuxtLink></h2>
                                <ul class="">
                                    <li>
                                        <NuxtLink :to="localePath('/customized-jewelry')">Bespoke {{ $t('customize') }} {{ $t('jewelry') }}
                                        </NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="right_cta_box">
                                <h2>Engagement Rings - Shop by Metal</h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'platinum-engagement-rings' } })">Platinum Engagement Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'white-gold-engagement-rings' } })">White Gold Engagement Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'yellow-gold-engagement-rings' } })">Yellow Gold Engagement Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'rose-gold-engagement-rings' } })">Rose Gold Engagement Rings</NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="right_cta_box">
                                <h2>Engagement Rings - Shop by Style</h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'solitaire-engagement-rings' } })">Solitaire Engagement Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'three-stone-engagement-rings' } })">Three Stone Engagement Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'side-stone-engagement-rings' } })">Side Stone Engagement Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'halo-engagement-rings' } })">Halo Engagement Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'vintage-engagement-rings' } })">Vintage Engagement Rings</NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="right_cta_box">
                                <h2>Engagement Rings - Shop by Shape</h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'round-rings' } })">Round Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'oval-rings' } })">Oval Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'pear-rings' } })">Pear Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'cushion-rings' } })">Cushion Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'princess-rings' } })">Princess Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'radiant-rings' } })">Radiant Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'emerald-rings' } })">Emerald Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'heart-rings' } })">Heart Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'asscher-rings' } })">Asscher Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'marquise-rings' } })">Marquise Rings</NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                     
                        <div class="col-lg-6 col-md-12">
                            <div class="right_cta_box">
                                <h2><NuxtLink :to="localePath('/engagement-ring-guide')">Engagement Ring Guide</NuxtLink></h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath('/engagement-ring-guide/ring-cost')">Average Engagement Ring Cost</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/engagement-ring-guide/types-of-diamonds')">Types of Diamond</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/engagement-ring-guide/types-of-ring-settings')">Types of Ring Settings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/engagement-ring-guide/complete-the-ring')">Complete The Ring</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/engagement-ring-guide/time-to-propose')">Time To Propose</NuxtLink></li>
                                </ul>
                            </div>
                            <div class="right_cta_box">
                                <h2>Customer Created Inspirations</h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath({ name: 'recently-purchase-carat', params:{slug : '1'}})">1 Carat Diamond Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'recently-purchase-carat', params:{slug : '2'}})">2 Carat Diamond Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'recently-purchase-carat', params:{slug : '3'}})">3 Carat Diamond Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'recently-purchase-shape', params:{slug : 'round'}})">Round Engagement Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'recently-purchase-shape', params:{slug : 'oval'}})">Oval Engagement Rings</NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                        <div class="right_cta_box">
                            <div class="menu_card">
                                <h2><NuxtLink :to="localePath({ name: 'preset-listing'})">Pre-designed engagement rings</NuxtLink></h2>
                                <div class="menu_ordered">
                                  <ul class="">
                                    <li><NuxtLink :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Round'
                                    } })">Round Pre-Designed Rings
                                    </NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Emerald'
                                    } })">Emerald Pre-Designed Rings
                                    </NuxtLink></li>
                                    <li><NuxtLink  :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Princess'
                                    } })">Princess Pre-Designed Rings
                                    </NuxtLink></li>
                                    <li><NuxtLink  :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Oval'
                                    } })">Oval Pre-Designed Rings
                                    </NuxtLink></li>
                                  </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div ref="div3" class="right_cta pt-5" id="wedding_ring">
                    <div class="right_cta_box">
                        <h2><NuxtLink :to="localePath('/wedding-rings')">Wedding Rings</NuxtLink></h2>
                        <ul class="">
                            <!-- <li><router-link :to="localePath('/')">Wedding Band</router-link></li> -->
                            <li><NuxtLink :to="localePath({ name:'shop-womens-wedding-rings' })">Women's Wedding Rings</NuxtLink></li>
                            <li><NuxtLink :to="localePath({ name:'shop-couple-rings' })">Couple Rings</NuxtLink></li>
                            <li><NuxtLink :to="localePath({ name:'shop-eternity' })">Eternity Rings</NuxtLink></li>
                            <li><NuxtLink  :to="localePath({ name: 'shop-anniversary',  query:{'Style': 'Five-stone'}})">Anniversary Rings</NuxtLink></li>
                        </ul>
                    </div>
                    <!-- <div class="right_cta_box">
                        <h2>Wedding Rings - Shop by Metal</h2>
                        <ul class="">
                            <li><router-link :to="localePath('/')">Platinum Wedding Bands</router-link></li>
                            <li><router-link :to="localePath('/')">White Gold Wedding Bands</router-link></li>
                            <li><router-link :to="localePath('/')">Yellow Gold Wedding Bands</router-link></li>
                            <li><router-link :to="localePath('/')">Rose Gold Wedding Bands</router-link></li>
                        </ul>
                    </div> -->
                </div>
                <div ref="div4" class="right_cta pt-5" id="loose">
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="right_cta_box">
                                <h2><NuxtLink :to="localePath('/lab-diamonds')">Lab Grown Diamonds</NuxtLink></h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })">Round Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'oval-cut-diamond' } })">Oval Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'pear-cut-diamond' } })">Pear Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'cushion-cut-diamond' } })">Cushion Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'princess-cut-diamond' } })">Princess Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'radiant-cut-diamond' } })">Radiant Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'emerald-cut-diamond' } })">Emerald Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'heart-cut-diamond' } })">Heart Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'asscher-cut-diamond' } })">Asscher Cut Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'marquise-cut-diamond' } })">Marquise Cut Diamonds</NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="right_cta_box">
                                <h2>Popular Searches</h2>
                                <ul class="">
                                    <!-- <li><router-link :to="localePath({ name:'loose-listing', params:{ start_with: 'quick-shipped' } })">Quick Shipped</router-link></li> -->
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'gia-certified' } })">GIA Certified Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'igi-certified' } })">IGI Certified Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/light-performance-report')">Light Performance Report</NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="right_cta_box">
                                <h2>Diamond Education</h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath('/4-cs-diamond')">The 4Cs of Diamond</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/ethical-and-conflict-free-diamonds')">Ethical and Conflict Free Diamonds</NuxtLink></li>
                                   
                                    <li><NuxtLink :to="localePath('/how-to-find-ring-size')">Find Your Ring Size</NuxtLink></li>
                                    <!-- <li><router-link :to="localePath('/how-to-find-ring-size')">Ring Size Guide</router-link></li> -->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div ref="div5" class="right_cta pt-5" id="jewelry">
                    <div class="row">
                        <div class="col-md-12 col-lg-6">
                            <div class="right_cta_box">
                                <h2><NuxtLink :to="localePath('/fine-jewelry')">Fine <span class="capitalize"> {{ $t('jewelry') }} </span> </NuxtLink></h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath({ name: 'shop-eternity'})">Eternity Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-anniversary',  query:{'Style': 'Five-stone'}})">Five Stone Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-anniversary',  query:{'Style': 'Seven-stone'}})">Seven Stone Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-couple-rings', params:{ category: 'couple-rings' }})">Couple Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-earring'})">Stud Earrings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-hoop'})">Hoop Earrings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-bracelet'})">Tennis Bracelets</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-fashion-bracelet'})">Fashion Bracelets</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-tennis-necklace'})">Tennis Necklaces</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name: 'shop-solitaire-necklace'})">Solitaire Necklaces</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'toi-et-moi-ring'})">Two Stone Rings</NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6" v-if="!$country.is_india">
                            <div class="right_cta_box">
                                <h2>Gifts</h2>
                                <ul class="">
                                    <li> <NuxtLink :to="localePath({ name:'shop-all', params:{ start_with: 'gifts-under-1000' } })"> Gifts Under $1000</NuxtLink></li>
                                    <li> <NuxtLink :to="localePath({ name:'shop-all', params:{ start_with: 'gifts-under-2000' } })"> Gifts Under $2000</NuxtLink></li>
                                    <li> <NuxtLink :to="localePath({ name:'shop-all', params:{ start_with: 'gifts-under-3000' } })"> Gifts Under $3000</NuxtLink></li>
                                    <li> <NuxtLink class="view_all_cta" :to="localePath({ name:'shop-all' })">View All</NuxtLink> </li>
                                </ul>
                            </div>
                            <div class="right_cta_box" v-if="!$country.is_india">
                                <h2>Ready To Ship</h2>
                                <ul class="">
                                    <li><router-link :to="localePath({ name:'instock_ring'})">In Stock engagement rings</router-link></li>
                                    <li><router-link :to="localePath({ name:'instock_pendant'})">In Stock Pendants</router-link></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6" v-else>
                            <div class="right_cta_box">
                                <h2>Gifts</h2>
                                <ul class="">
                                    <li> <NuxtLink :to="localePath({ name:'shop-all', params:{ start_with: 'gifts-under-50000' } })"> Gifts Under {{ $formatPrice(50000) }}</NuxtLink></li>
                                    <li> <NuxtLink :to="localePath({ name:'shop-all', params:{ start_with: 'gifts-under-80000' } })"> Gifts Under {{ $formatPrice(80000) }}</NuxtLink></li>
                                    <li> <NuxtLink :to="localePath({ name:'shop-all', params:{ start_with: 'gifts-under-100000' } })"> Gifts Under {{ $formatPrice(100000) }}</NuxtLink></li>
                                    <li> <NuxtLink class="view_all_cta" :to="localePath({ name:'shop-all' })">View All</NuxtLink> </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div ref="div6" class="right_cta pt-5" id="about">
                    <div class="row">
                        <div class="col-md-12 col-lg-6">
                            <div class="right_cta_box">
                                <h2><NuxtLink :to="localePath('/about-us')">About Us</NuxtLink></h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath('/our-story')">Our Story</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/our-share-of-care')">Giving Back To The Community</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/ethical-and-conflict-free-diamonds')">Ethical & Conflict Free Diamonds</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/friendly-diamond-difference')">The Friendly Diamonds' Difference</NuxtLink></li>
                                    <li v-if="!$country.is_india"><NuxtLink :to="localePath('green-and-sustainable-gift')">Giving Back to Our Planet</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/testimonials')">Testimonials</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/free-product')">Free Product</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/press')">Press</NuxtLink></li>
                                </ul>
                            </div>
                            <div class="right_cta_box">
                                <h2>Services & Values</h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath('/customer-service')">Customer Services</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/customer-service/shipping-policy')">Shipping Policy</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/customer-service/return-policy')">Return Policy</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/customer-service/exchange-policy')">Lifetime Trade-In</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/customer-service/ring-resizing')">Ring Resizing</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/customer-service/ring-engraving')">Ring Engraving</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/customer-service/payment-options')">Payment Option</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/customer-service/life-time-warranty')">Lifetime Warranty</NuxtLink></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <div class="right_cta_box">
                                <h2>Policy Pages</h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath('/terms-of-service')">Terms & Condition</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/privacy-policy')">Privacy Policy</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/cookie-policy')">Cookie Policy</NuxtLink></li>
                                </ul>
                            </div>
                            <div class="right_cta_box">
                                <h2><NuxtLink :to="localePath({ name:'blog-listing'})">Friendly Diamonds Blog</NuxtLink></h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath({ name:'blog-listing', params:{ type: 'category', sub_type: 'new-trends' } })">New Trends</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'blog-listing', params:{ type: 'category', sub_type: 'gift-ideas' } })">Gift Ideas</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'blog-listing', params:{ type: 'category', sub_type: 'diamond-guide' } })">Diamond Guide</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'blog-listing', params:{ type: 'category', sub_type: 'all-about-rings' } })">All About Rings</NuxtLink></li>
                                    <li><NuxtLink :to="localePath({ name:'blog-listing', params:{ type: 'category', sub_type: 'jewelry-guide' } })"> <span class="capitalize">{{ $t('jewelry') }}</span> Guide</NuxtLink></li>
                                </ul>
                            </div>
                            <div class="right_cta_box">
                                <h2>Contact</h2>
                                <ul class="">
                                    <li><NuxtLink :to="localePath('/contact-us')">Contact Us</NuxtLink></li>
                                    <li><NuxtLink :to="localePath('/appointment')"> Book Appointment</NuxtLink></li>
                                    <!-- <li><router-link :to="localePath('/')"> Career</router-link></li> -->
                                </ul>
                            </div>
                        </div>
                      
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
useFetchMeta( useNuxtApp(), useRuntimeConfig() );
    const localePath = useLocalePath();
    const { $country } = useNuxtApp();

    const activeMenuItem = ref('menu-item-1');
    const div1 = ref(null);
    const div2 = ref(null);
    const div3 = ref(null);
    const div4 = ref(null);
    const div5 = ref(null);
    const div6 = ref(null);

    const handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop;

        const div1Top = div1.value.getBoundingClientRect().top + scrollTop + 40;
        const div2Top = div2.value.getBoundingClientRect().top + scrollTop + 40;
        const div3Top = div3.value.getBoundingClientRect().top + scrollTop + 40;
        const div4Top = div4.value.getBoundingClientRect().top + scrollTop + 40;
        const div5Top = div5.value.getBoundingClientRect().top + scrollTop + 40;
        const div6Top = div6.value.getBoundingClientRect().top + scrollTop + 40;

        if (div1Top <= scrollTop && scrollTop < div2Top) {
            activeMenuItem.value = 'menu-item-1';
        } else if (div2Top <= scrollTop && scrollTop < div3Top) {
            activeMenuItem.value = 'menu-item-2';
        } else if (div3Top <= scrollTop && scrollTop < div4Top) {
            activeMenuItem.value = 'menu-item-3';
        } else if (div4Top <= scrollTop && scrollTop < div5Top) {
            activeMenuItem.value = 'menu-item-4';
        } else if (div5Top <= scrollTop && scrollTop < div6Top) {
            activeMenuItem.value = 'menu-item-5';
        } else if (div6Top <= scrollTop) {
            activeMenuItem.value = 'menu-item-6';
        } else {
            activeMenuItem.value = null;
        }
    };

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
    });

</script>

<style scoped>
h1 {
    font-size: 32px;
}
.left_cta ul li, .left_cta ul li a {
    list-style: none;
    padding: 2px 0;
    color: #000;
    font-weight: 600;
    line-height: 2;
    text-transform: uppercase;
    font-size: 13px;
}
h2, h2 a { 
    font-size: 18px;
    color: #303030;
    font-weight: 600;
    margin-bottom: 13px;
}
.right_cta_box {
    margin-bottom: 40px;
}
.right_cta_box ul {
    padding-left: 31px;
}
.right_cta_box ul li a {
    color: #606060;
    line-height: 1.9;
}
.left_cta ul li a.active{
    color: var(--green);
}

.capitalize{
    text-transform: capitalize;
}
@media (max-width: 767px){
    .container {
        margin-top: 40px;
    }
    .right_cta_box { 
        margin-bottom: 20px;
    }
    .right_cta {
        padding-top: 0 !important;
    }
}
@media (min-width: 768px){
    .sticky {
        position: sticky;
        top: 5px;
        height: -moz-fit-content;
        height: fit-content;
    }
}

</style>
